/** @jsxImportSource @emotion/react */

import { vars } from "@imwebme/clay-token";
import { Typography } from "../Typography";
import { Flex } from "../utilities";
import { PROGRESS_BAR_DEFAULT_SIZE } from "./ProgressBar.constants";
import { ProgressBarContainer } from "./ProgressBar.container";
import { ProgressBarCore } from "./ProgressBar.core";
import type { ProgressBarPercentProps, ProgressBarStepProps } from "./ProgressBar.types";

const ProgressBarPercent = ({
  size = PROGRESS_BAR_DEFAULT_SIZE,
  value,
  ...rest
}: ProgressBarPercentProps) => (
  <ProgressBarContainer>
    <ProgressBarCore value={value} size={size} {...rest} />

    <Typography css={{ width: size === "medium" ? 44 : 38 }} variant={`label-${size}`}>
      {value}%
    </Typography>
  </ProgressBarContainer>
);

const ProgressBarStep = ({
  size = PROGRESS_BAR_DEFAULT_SIZE,
  value,
  maxStep,
  ...rest
}: ProgressBarStepProps) => (
  <ProgressBarContainer>
    <ProgressBarCore value={(value / maxStep) * 100} size={size} {...rest} />

    <Flex
      justifyContent="flex-end"
      gap={vars.spacing["05"]}
      width={size === "medium" ? 64 : 56}
      {...vars.semantic.typography[`label-${size}`]}
    >
      <span>
        {value}/{maxStep}
      </span>
      <span>단계</span>
    </Flex>
  </ProgressBarContainer>
);

const ProgressBarNameSpace = {
  Percent: ProgressBarPercent,
  Step: ProgressBarStep,
  Core: ProgressBarCore,
};

export { ProgressBarNameSpace as ProgressBar };
